import { useState } from 'react';

const useUpdateTalentStatus = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateTalentStatus = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/talent-pool/${id}/approve`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (err) {
            setError(err);
            throw err; // Re-throw the error so it can be caught by the calling component
        } finally {
            setLoading(false);
        }
    };

    return { updateTalentStatus, loading, error };
};

export default useUpdateTalentStatus;

